/**
 * Normaliza o primeiro segmento de URL para arquivos de taxonomia (categorias/tags).
 * Usado com valores do CMS e com `NEXT_PUBLIC_*`.
 */
export function normalizeTaxonomyUrlSegment(value: string | null | undefined): string | null {
  if (value == null) return null
  const s = String(value)
    .trim()
    .replace(/^\/+|\/+$/g, '')
    .toLowerCase()
  if (!s || s.includes('..') || s.includes('/')) return null
  return s
}
